module.exports = __webpack_public_path__ + "img/9.bd83cf15.png";